import wixData from 'wix-data';

$w.onReady(function () {
	//TODO: write your page related code here...

});



export function input1_keyPress_4(event) {
let SearchValue = $w("#input1").value;
$w("#dataset1").setFilter(wixData.filter().contains('organisationName', SearchValue));
}